import { AnchorHTMLAttributes, ButtonHTMLAttributes, PropsWithChildren } from 'react'

import Link from '~/components/Link'

import { ChevronIcon } from '../Icons/ChevronIcon'

import styles from './Button.module.css'

type BaseProps = {
  size?: 'small' | 'large'
  variant?: 'primary' | 'ghost' | 'outlined'
  className?: string
  withArrow?: boolean
  disabled?: boolean
  fullWidth?: boolean
}

type ButtonBaseProps = BaseProps & ButtonHTMLAttributes<HTMLButtonElement> & { href?: never }

type LinkProps = BaseProps & Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> & { href: string }

export type ButtonProps = ButtonBaseProps | LinkProps

export const Button = ({
  href,
  size = 'large',
  variant = 'primary',
  children,
  className,
  withArrow = false,
  disabled,
  fullWidth = false,
  ...rest
}: PropsWithChildren<ButtonProps>) => {
  const combinedClassName = `${styles.button} ${styles[size] ?? ''} ${styles[variant] ?? ''} ${className ?? ''} ${fullWidth ? styles.fullWidth : ''}`
  const iconRight = withArrow ? <ChevronIcon className={styles.iconRight} /> : null

  if (href) {
    const linkProps = rest as LinkProps
    return (
      <Link className={combinedClassName} {...linkProps} href={href}>
        {children}
        {iconRight}
      </Link>
    )
  } else {
    const buttonProps = rest as ButtonBaseProps
    return (
      <button className={combinedClassName} disabled={disabled} type={buttonProps.type} {...buttonProps}>
        {children}
        {iconRight}
      </button>
    )
  }
}
